<template>
    <div class="main">
        <div class="text-center">
            <h1 class="my-10" v-text="$t('CONTACT_US_RIGHT_TO_CANCEL')"></h1>
        </div>

        <div class="container mx-auto px-6 xl:px-0 pb-12">
            <div class="text-left w-full lg:w-2/3 mx-auto">
                <ul>
                    <li
                        v-for="(terms, index) in rightToCancel"
                        :key="index"
                        class="mb-6">
                        <p
                            v-for="(paragraph, index) in terms"
                            :key="index"
                            class="ml-4"
                            v-html="paragraph">
                        </p>
                    </li>
                </ul>
            </div>
        </div>

    </div>
</template>
<script>
export default {
    name: 'RightToCancel',
    data() {
        return {
            rightToCancel: '',
        };
    },
    mounted() {
        this.setRightToCancel();
    },
    methods: {
        async setRightToCancel() {
            const RtoC = await require(`@/content/${process.env.VUE_APP_COUNTRY_ISO}/${process.env.VUE_APP_I18N_LOCALE}/RightToCancel`);
            this.rightToCancel = RtoC.items;
            // import('@/content/AUT/de/RightToCancel').then(module => module.default).then(response => {
            //     this.rightToCancel = response.items;
            // });
        },
    },
};
</script>
